import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdmin, isSuperAdmin } from 'app/utils/authUtilities';
import useStore, { IStore } from 'app/store';
import { UserDto } from 'generated/request-backend';

/**
 * This component is used to redirect the generic request details to appropriate request details page based on role.
 */
export const RequestDetailsRoute: React.FC<{
    path: string | string[];
    exact?: boolean;
}> = (props) => {
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails as UserDto);
    const condition = isAdmin(userDetails?.userRoles) || isSuperAdmin(userDetails?.userRoles);
    return (
        <Route
            path={props.path}
            exact={props.exact}
            render={({ match }) =>
                condition ? (
                    <Redirect to={`/request-detail/${match.params.id}`} />
                ) : (
                    <Redirect to={`/request/${match.params.id}`} />
                )
            }
        />
    );
};
